import React, { useContext } from "react";

import "../../../../assets/css/utility/progress-bar.css";
import { ManageLoadPostContext } from "..";

const ProgressBar = () => {
  const [loadPostState] = useContext(
    ManageLoadPostContext
  );

  return (
    <>
      <section id="load-post-progress-bar">
        <div className="container theme-section">
          {/* completed="4" change able vale 1-5 */}
          <div className="progress-bar-length" completed="2">
            <div className="progress-bar-box" progress="1">
              <div className="progress-bar-cercle">
                <i className="fa-solid fa-check-double"></i>
              </div>
              <span>Address Information</span>
            </div>

            <div
              className="completed-line"
              progress-line={loadPostState.stepNumber === 2 ? "1" : "0"}
            ></div>

            <div
              className="progress-bar-box"
              progress={loadPostState.stepNumber === 2 ? "2" : "0"}
            >
              <div className="progress-bar-cercle">
                <i className="fa-solid fa-check-double"></i>
              </div>
              <span>Loads Information</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default React.memo(ProgressBar);
